// src/services/facturacionPlanesService.js
import api from './api';

function apiBase() {
  return (api.defaults.baseURL || '').replace(/\/+$/, '');
}

const facturacionPlanesService = {
  // ── Planes a facturar ───────────────────────────────────────────
  async listar() {
    const res = await api.get('/admin/facturacion-planes');
    return res.data?.data || [];
  },

  async facturar(suscripcionId, ciclo) {
    const res = await api.post(`/admin/facturacion-planes/${suscripcionId}/facturar`, { ciclo });
    return res.data;
  },

  // Genera la factura de todas las suscripciones vigentes pendientes
  async facturarTodos(diasAnticipacion = 15) {
    const res = await api.post('/admin/facturacion-planes/facturar-todos', { dias_anticipacion: diasAnticipacion });
    return res.data;
  },

  async firmar(facturaId) {
    const res = await api.post(`/admin/facturacion-planes/factura/${facturaId}/firmar`, {});
    return res.data;
  },

  async anular(facturaId, motivo) {
    const res = await api.post(`/admin/facturacion-planes/factura/${facturaId}/anular`, { motivo });
    return res.data;
  },

  pdfUrl(facturaId) {
    return `${apiBase()}/admin/facturacion-planes/factura/${facturaId}/pdf`;
  },

  // ── Facturas emitidas ───────────────────────────────────────────
  async listarFacturas(params = {}) {
    const res = await api.get('/admin/facturacion-planes/facturas', { params });
    // FacturaController devuelve { data: { facturas: [...] } }
    return res.data?.data?.facturas || [];
  },

  // ── Emisor: configuracion / logo / firma / secuenciales ─────────
  async obtenerConfigEmisor() {
    const res = await api.get('/admin/emisor/configuracion');
    return res.data?.data || null;
  },

  async guardarAmbiente(ambiente) {
    const res = await api.put('/admin/emisor/ambiente', { ambiente });
    return res.data;
  },

  async subirLogo(file) {
    const fd = new FormData();
    fd.append('logo', file);
    const res = await api.post('/admin/emisor/logo', fd, { headers: { 'Content-Type': 'multipart/form-data' } });
    return res.data;
  },

  logoUrl(logoRuta) {
    if (!logoRuta) return null;
    const root = apiBase().replace(/\/api$/, '');
    return `${root}/${String(logoRuta).replace(/^\/+/, '')}`;
  },

  async obtenerFirma() {
    const res = await api.get('/admin/emisor/firma');
    return res.data?.data || null;
  },

  async guardarFirma(file, password) {
    const fd = new FormData();
    fd.append('p12_file', file);
    fd.append('cert_password', password);
    const res = await api.post('/admin/emisor/firma', fd, { headers: { 'Content-Type': 'multipart/form-data' } });
    return res.data;
  },

  async obtenerSecuenciales() {
    const res = await api.get('/admin/emisor/secuenciales');
    return res.data?.data || [];
  },

  async guardarSecuencial(eep_id, document_type, sequence) {
    const res = await api.put('/admin/emisor/secuenciales', { eep_id, document_type, sequence });
    return res.data;
  },
};

export default facturacionPlanesService;
